import braintree from 'braintree-web';

let clientInstance;
let dataCollectorInstance;
let hostedFieldsInstance;
let threeDSecureInstance;
let paypalInstance;

const setupBraintreeIntegration = async function(conf) {
    try {
        clientInstance = await braintree.client.create({
            authorization: conf.clientToken
        });

        dataCollectorInstance = await braintree.dataCollector.create({
            client: clientInstance,
            kount: true,
            paypal: conf.isPayPayEnabled
        });

        const options = {
            client: clientInstance,
            styles: {
                // Style all elements
                input: {
                    'font-size': '12pt',
                    color: '#333333',
                    'padding-left': '5px'
                },
                // Styling a specific field
                '.number': {
                    //'font-family': 'monospace'
                },
                // Styling element state
                ':focus': {
                    color: '#333333'
                },
                '.valid': {
                    color: 'green'
                },
                '.invalid': {
                    color: 'red'
                },
                // Media queries
                // Note that these apply to the iframe, not the root window.
                '@@media screen and (max-width: 700px)': {
                    input: {
                        'font-size': '14pt'
                    }
                }
            },
            fields: {
                number: { selector: '#card-number' },
                cvv: { selector: '#cvv', placeholder: 'XXX' },
                expirationDate: {
                    selector: '#expiration-date',
                    placeholder: conf.texts.expirationDate_placeHolder
                }
            }
        };

        if (conf.isCardEnabled) {
            hostedFieldsInstance = await braintree.hostedFields.create(options);

            hostedFieldsInstance.on('validityChange', function(event) {
                const field = event.fields[event.emittedBy];
                conf.onCardValidation(event.emittedBy, field.isValid);
            });

            threeDSecureInstance = await braintree.threeDSecure.create({
                version: 2, // Will use 3DS 2 whenever possible
                client: clientInstance
            });
        }

        if (conf.isPayPayEnabled) {
            paypalInstance = await braintree.paypal.create({
                client: clientInstance
            });
        }

        conf.onSetupReady(dataCollectorInstance.deviceData);
    } catch (error) {
        conf.onError(error);
    }
};

export default {
    setup: setupBraintreeIntegration,

    teardown: async onTeardownComplete => {
        if (paypalInstance) {
            await paypalInstance.teardown();
        }
        if (threeDSecureInstance) {
            await threeDSecureInstance.teardown();
        }
        if (hostedFieldsInstance) {
            await hostedFieldsInstance.teardown();
        }
        await dataCollectorInstance.teardown();
        await clientInstance.teardown();
        onTeardownComplete();
    },

    tokenizePaypalAccount: async (amount, tokenizeComplete, onError) => {
        try {
            const payload = await paypalInstance.tokenize({
                flow: 'checkout',
                amount: amount,
                currency: 'SEK',
                locale: 'sv_se'
            });

            tokenizeComplete(payload.nonce, payload.details.email);
        } catch (error) {
            if (error.code !== 'PAYPAL_POPUP_CLOSED') {
                onError(error);
            }
        }
    },

    tokenizeCard: async (onTokenizeComplete, onError) => {
        try {
            const payload = await hostedFieldsInstance.tokenize();
            onTokenizeComplete(payload);
        } catch (error) {
            onError(error);
        }
    },

    verifyCardWith3DSecure: async (
        tokenizationPayload,
        amount,
        threeDSecureData,
        onVerifyComplete
    ) => {
        const threeDSecureParameters = {
            amount: amount,
            nonce: tokenizationPayload.nonce,
            bin: tokenizationPayload.details && tokenizationPayload.details.bin,
            email: threeDSecureData.email,
            billingAddress: threeDSecureData.billingAddress,
            additionalInformation: threeDSecureData.additionalInformation,
            onLookupComplete: (data, next) => {
                // use `data` here, then call `next()`
                next();
            }
        };

        try {
            const payload = await threeDSecureInstance.verifyCard(
                threeDSecureParameters
            );

            onVerifyComplete(null, payload);
        } catch (error) {
            onVerifyComplete(error || { message: 'undefined error' }, null);
        }
    }
};
